
import { i18nText } from '@/locales';
type ServicePrices = { price_first: number | string; price_second: number | string };

// Legacy staff_cosmetolog_categories: 1 = ведущий, 2 = обычный мастер.
export function servicePrice(service: ServicePrices, categoryId: number | string): number {
    return Number(Number(categoryId) === 1 ? service.price_second : service.price_first);
}

export function lineAmount(line: { price: number | string; quantity: number | string; discount?: number | string }): number {
    const discount = Math.max(0, Math.min(100, Number(line.discount || 0)));
    return Math.round(Number(line.price) * Number(line.quantity) * (1 - discount / 100) * 100) / 100;
}

export function selectedClient<T extends { id: number }>(client: T | null, clientId: number | string | null): T | null {
    return client && Number(client.id) === Number(clientId) ? client : null;
}

export function receiptLines(basket: Record<string, any[]> | null | undefined): Array<Record<string, any>> {
    const labels: Record<string, string> = { services: i18nText("Услуга"), products: i18nText("Товар"), certificates: i18nText("Сертификат"), memberships: i18nText("Абонемент") };
    const kinds = Object.keys(labels);
    return kinds.reduce((rows: Array<Record<string, any>>, kind) => {
        return rows.concat((basket?.[kind] || []).map((line) => ({
            key: `${kind}-${line.id}`,
            name: line.service?.name || line.product?.nomenclature?.name || line.product?.name ||
                line.certificate?.name || line.membership?.name || line.name ||
                labels[kind],
            quantity: Number(line.quantity),
            price: Number(line.price),
            discount: Number(line.discount || 0),
            amount: lineAmount(line),
        })));
    }, []);
}

export function receiptVisitId(params: Record<string, string>): number {
    const id = Number(params.id || JSON.parse(params.form || '{}').form?.visit_id);
    if (!Number.isSafeInteger(id) || id <= 0) throw new Error(i18nText("Визит не найден"));
    return id;
}
